import { useContext } from 'react';
import { ExperimentContext } from '../../components/Experimenter/Context';

export function useGetExperimentGroupById(experimentId: string) {
  const { allocations } = useContext(ExperimentContext);
  const group = allocations.find((allocation) => allocation.experimentIdentifier === experimentId)?.group;

  return group;
}
